import React, { useContext, useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/react-hooks";
import Queries from "../Queries";
import { GlobalContext } from "./../Context";
import "./BranchButton.scss";

export const BranchButton = ({ data }) => {
  const globalContext = useContext(GlobalContext);
  const {
    langcode,
    setAdvancedFiltersVisibility,
    setCurrentPopUp,
    mapsInstance,
    initialPos,
    radius,
    setBranches,
    setFiltersVisibility,
    setResultsState,
    setMarkersVisibility,
    setActiveFilters,
    setBranchSchedulesVisibility,
    categoryFilters,
    setCategoryFilters,
    setCategorySelected,
    backButtonVisibility,
    isResultView,
    filterCardState,
    filtersVisibility,
  } = globalContext;

  const [, setQueryState] = useState("waiting");
  const [tids, setTids] = useState("");
  const [getBranches, queryResult] = useLazyQuery(Queries("branches"), {
    variables: {
      langcode: langcode,
      tids: tids,
      field_coordinates_proximity: `${initialPos.lat},${initialPos.lng}<${
        radius / 1000
      }km`,
    },
  });

  const handleService = () => {
    if (categoryFilters && categoryFilters.length !== 0) {
      const categoryIds = categoryFilters[0].fieldOptionsType.map(
        (optionType) => `${optionType.tid}`
      );
      const newTids = categoryIds.join("+");

      setCategorySelected(categoryFilters[0]);
      setTids(newTids);

      if (isResultView) {
        setActiveFilters(categoryIds);
      } else {
        setBranchSchedulesVisibility(true);
      }

      getBranches({
        variables: {
          langcode,
          tids: newTids,
          field_coordinates_proximity: `${initialPos.lat},${initialPos.lng}<${radius / 1000}km`,
        },
      });
    }
  };

  useEffect(() => {
    if (data && data.filtersByCountry.results.length !== 0) {
      setCategoryFilters(data.filtersByCountry.results[0].fieldAdvancedFilters);
    }
  }, [data, categoryFilters, setCategoryFilters]);

  useEffect(() => {
    if (queryResult.data && mapsInstance) {
      let { google } = mapsInstance;
      let queryCircle = new google.maps.Circle({
        strokeColor: "#FF0000",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        center: new google.maps.LatLng(initialPos),
        radius: radius,
      });
      let markers = [];
      queryResult.data.officeBranchesQuery.results.forEach((item) => {
        let location = new google.maps.LatLng({
          lat: item.fieldCoordinates.lat,
          lng: item.fieldCoordinates.lng,
        });
        let marker = new google.maps.Marker({
          position: location,
        });
        if (
          google.maps.geometry.spherical.computeDistanceBetween(
            marker.getPosition(),
            queryCircle.getCenter()
          ) <= queryCircle.getRadius()
        ) {
          markers.push(item);
        }
      });

      if (markers.length > 0) {
        setQueryState("success");
        setBranches(markers);
        setAdvancedFiltersVisibility(false);
        setMarkersVisibility(true);
        if (isResultView) {
          setResultsState(true);
          setFiltersVisibility(false);
          setCurrentPopUp(false);
        } else {
          if (tids === "") {
            setBranchSchedulesVisibility(false);
            setResultsState(false);
            setBranches([]);
            setMarkersVisibility(false);
            setCurrentPopUp(false);
          } else {
            setBranchSchedulesVisibility(true);
          }
        }
      } else {
        setQueryState("fails");
      }
    }
  }, [
    tids,
    queryResult,
    mapsInstance,
    isResultView,
    initialPos,
    radius,
    setBranches,
    setFiltersVisibility,
    setResultsState,
    setMarkersVisibility,
    setCurrentPopUp,
    setAdvancedFiltersVisibility,
    setBranchSchedulesVisibility,
  ]);

  return (
    <button
      className={`card-teaser-list__branch ${
        !backButtonVisibility && filterCardState !== "open" && filtersVisibility ? "card-teaser-list__branch--open" : ""
      }`}
      onClick={handleService}
    >
      Ver horario de sucursales
    </button>
  );
};
